import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from 'react';
import { cn } from "utils/cn";

const loadingAIPlaceholders = [
    "Your InnerCircle is thinking…",
    "Claro is rounding up assets…",
    "Looking at the screenshot…",
    "Refreshing the refresh…",
    "Inspecting code and design…",
    "Double-checking the obvious…",
    "Whispering to the pixels…",
    "Opening six tabs at once…",
    "Hmm.. Let’s get on a call…",
    "Quietly judging spacing…",
    "Reviewing 2.5k-item checklist...",
    "Asking “but what if…”",
    "Exploring paths less clicked…",
    "Fixing what isn’t broken…",
    "Losing an argument with a div…",
    "Waiting for caffeine…",
    "Accessing other tools…",
    "Dusting off old audits…",
    "Poking buttons to break them…",
    "Rethinking that one decision…",
    "Scanning every tag and title…",
    "On a silent group huddle…",
]

export function DesignReviewIndicator({ className, indicatorClassName }: { className?: string, indicatorClassName?: string }) {
    const [currentPlaceholder, setCurrentPlaceholder] = useState(loadingAIPlaceholders[0]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentPlaceholder(loadingAIPlaceholders[Math.floor(Math.random() * loadingAIPlaceholders.length)]);
        }, 2000);

        return () => clearInterval(interval);
    }, []);



    return (
        <AnimatePresence>
            <motion.div
                key="typing-indicator"
                initial={{ opacity: 0, height: '0' }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: '0' }}
                transition={{ duration: 0.2 }}
                className={cn("text-sm text-gray-400 italic -mt-2 max-w-80 truncate flex gap-1.5", className)}
            >
                <div className={cn('flex gap-0.5 justify-center items-center', indicatorClassName)}>
                    <div className={cn(
                        'h-1.5 w-1.5 rounded-[50%_15%_50%_50%] animate-typing-bounce [animation-delay:-0.3s]',
                        "bg-ata-orange/50")}></div>
                    <div className={cn(
                        'h-1.5 w-1.5 rounded-[50%_15%_50%_50%] animate-typing-bounce [animation-delay:-0.15s]',
                        "bg-ata-purple/50")}></div>
                    <div className={cn(
                        'h-1.5 w-1.5 rounded-[50%_15%_50%_50%] animate-typing-bounce',
                        "bg-ata-pink/50")}></div>
                </div>
                {currentPlaceholder}
            </motion.div>
        </AnimatePresence>
    );
}